import React from "react";

//impotr libs
import {
  Row,
  Col,
  Table,
  Button,
  Radio,
  Tooltip,
  Input,
  Spin,
  PageHeader,
} from "antd";
import "antd/dist/antd.css";
import { DownOutlined } from "@ant-design/icons";
import Dialog from "../shared/dialog";

//import dom
import { Link } from "react-router-dom";
import HeaderComponent from "../components/HeaderComponent";

export default class LeaderFormScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      tableData: [],
      ansFormArray: [],
      headerForm: [],
      Tooltip: [],
      //RUN: เพิ่ม Weight 14/04/2021
      weight: [],
      record: [],
      //RUN: เพิ่ม การ get Language 16/04/2021
      language: localStorage.getItem("Language"),
      titleTH:
        "แบบประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหารมหาวิทยาลัยพายัพประจำปีการศึกษา 2564",
      titleEN:
        "Appraisal of administrators on their leadership and administrative capacity in accordance with principles of good governance for the Academic Year 2564 ",
    };
    this.AnsData = {
      ansForm: [],
      ansFormArray: [],
      ansTotalClick: [],
      ansTotalClickTopic: [],
      ansTotalClickSubSubTopic: [],
      TotalCalculate: 0,
    };

    this.initArrays = {
      TopicsArr: [],
      SubTopicArr: [],
      SubSubTopicArr: [],
      //RUN: เพิ่ม ตัวแปร array เก็บค่า 14/04/2021
      InProgressForm: [],
    };

    this.FromLocal = {
      PositionID: parseInt(this.props.location.state.record.PositionId),
    };

    this.dialog = new Dialog();
  }

  // changeLangFunction(item) {
  //   localStorage.setItem("Language", item);
  //   this.setState({ language: item });
  // }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps", nextProps);
    this.setState({ language: nextProps.lang });
    localStorage.setItem("Language", nextProps.lang);
  }

  componentDidMount() {
    // window.history.pushState(null,null,window.location.pathname)

    if (localStorage.getItem("EmpId")) {
      this.spinnerControl();

      // this.FromLocal.PositionID = parseInt(localStorage.getItem("PositionID"));
      // //RUN: เพิ่มการดึง GroupPositionID มาจาก LocalStorage

      // this.FromLocal.PositionGroupID = localStorage.getItem("GroupPositionID");
      console.log("in if");
      fetch(process.env.REACT_APP_API_URL + "/api/getCriteriaAndUserAnsLeader", {
        method: "post",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        body: JSON.stringify({
          empid: this.props.location.state.record.empId,
          assessor: this.props.location.state.record.LeaderId,
          formtypeid: 3,
          field: 99,
        }),
      })
        .then((Response) => Response.json())
        .then((result) => {
          console.log("result: ", result);
          result.forEach((e) => {
            this.initArrays.TopicsArr = e.Topics;
            this.initArrays.SubTopicArr = e.SubTopics;
            //RUN : เพิ่มการ ใส่ InProgress หากมี หากไม่มีจะใส่เป็น array เปล่าซึ่งไม่มีผลใดๆกับ Process 16/04/2021
            this.initArrays.InProgressForm = e.AnsForm;
            this.initArrays.SubSubTopicArr = e.SubSubTopics;
          });
          console.log("localStorage.getItem()", localStorage.getItem("Field"));
          //RUN: นำ ans data เข้าไปใส่ใน array ที่ใช้ ิวิ่งข้อมูล Default
          if (this.initArrays.InProgressForm.length > 0) {
            this.initArrays.InProgressForm.forEach((e) => {
              this.AnsData.ansForm.push({
                TopicId: e.TopicId,
                SubTopicId: e.SubTopicId,
                SubSubTopicId: e.SubSubTopicId,
                Point: e.Point,
                Remark: e.Remark,
                CalPoint: e.CalPoint,
                isCompetency: e.isCompetency,
              });
            });
          }

          //RUN: เพิ่ม การตรวจสอบ employee คนนี้มีตำแหน่งอะไรและเลือกใช้ Weightให้ ถูกต้อง
          var tempWeightApplySubTopic;

          this.initArrays.SubTopicArr.forEach((e) => {
            this.state.Tooltip.push({
              ToppicId: e.ToppicId,
              SubToppicId: e.SubToppicId,
              SubSubToppicId: 0,
              Tooltip1TH: e.Tooltip1TH,
              Tooltip1EN: e.Tooltip1EN,
              Tooltip2TH: e.Tooltip2TH,
              Tooltip2EN: e.Tooltip2EN,
              Tooltip3TH: e.Tooltip3TH,
              Tooltip3EN: e.Tooltip3EN,
              Tooltip4TH: e.Tooltip4TH,
              Tooltip4EN: e.Tooltip4EN,
              Tooltip5TH: e.Tooltip5TH,
              Tooltip5EN: e.Tooltip5EN,
              WeightBoards: e.WeightBoards,
              WeightLecturer: e.WeightLecturer,
              WeightLecturerOfficer: e.WeightLecturerOfficer,
              WeightOfficer: e.WeightOfficer,
              //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
              WeightCriteria: tempWeightApplySubTopic,


            });
          });

          var tempWeightApplySubSubTopic;
          this.initArrays.SubSubTopicArr.forEach((e) => {
            this.state.Tooltip.push({
              ToppicId: e.ToppicId,
              SubToppicId: e.SubToppicId,
              SubSubToppicId: e.SubSubToppicId,
              Tooltip1TH: e.Tooltip1TH,
              Tooltip1EN: e.Tooltip1EN,
              Tooltip2TH: e.Tooltip2TH,
              Tooltip2EN: e.Tooltip2EN,
              Tooltip3TH: e.Tooltip3TH,
              Tooltip3EN: e.Tooltip3EN,
              Tooltip4TH: e.Tooltip4TH,
              Tooltip4EN: e.Tooltip4EN,
              Tooltip5TH: e.Tooltip5TH,
              Tooltip5EN: e.Tooltip5EN,
              WeightBoards: e.WeightBoards,
              WeightLecturer: e.WeightLecturer,
              WeightLecturerOfficer: e.WeightLecturerOfficer,
              WeightOfficer: e.WeightOfficer,
              //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
              WeightCriteria: tempWeightApplySubSubTopic,
              showRemark: false,
              //RUN: เพิ่ม field isCompetency เพื่อใช้ตรวจสอบการ ว่าเป็นการประเมินด้าน สมรรณถนะ 18/04/2021
              isCompetency: e.isCompetency,
            });
          });

          console.log("this.state.Toolstip.", this.state.Tooltip);
          console.log(
            "sssssssssssssssssssssss",
            this.initArrays.InProgressForm
          );
          this.setState({ tableData: result });
          this.spinnerControl();
        });
    } else {
    }
  }

  // Run: ควบคุมการ Change ของ Button 08/04/2021
  handleChange = (
    ToppicId,
    SubToppicId,
    SubSubToppicId,
    value,
    indexfromRen,
    parentIndex,
    // RUN: เพิ่ม isCompetency เพื่อทำการ ตรวจสอบ comtency 14/04/2021
    isCompetency,
    // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
    WeightCriteria
  ) => {
    var temp = [];
    var tempcalPoint = 0;
    temp = this.AnsData.ansForm.filter((e) => {
      return (
        e.TopicId == ToppicId &&
        e.SubTopicId == SubToppicId &&
        e.SubSubTopicId == SubSubToppicId
      );
    });

    console.log("tempcalPoint", tempcalPoint);
    if (temp.length == 0) {
      this.AnsData.ansForm.push({
        TopicId: ToppicId,
        SubTopicId: SubToppicId,
        SubSubTopicId: SubSubToppicId,
        Point: value, //ดึงคะแนนของหัวข้อมา
        Remark: "", //ดึงเหตุผลของหัวข้อมา
        // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
        CalPoint: tempcalPoint,
        isCompetency: isCompetency,
      });
    } else {
      this.AnsData.ansForm = this.testarrayDupFunction(
        ToppicId,
        SubToppicId,
        SubSubToppicId
      );

      this.AnsData.ansForm.push({
        TopicId: ToppicId,
        SubTopicId: SubToppicId,
        SubSubTopicId: SubSubToppicId,
        Point: value, //ดึงคะแนนของหัวข้อมา
        Remark: "", //ดึงเหตุผลของหัวข้อมา
        // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
        CalPoint: tempcalPoint,
        isCompetency: isCompetency,
      });
    }
    //RUN: เพิ่ม Condition การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
    if (isCompetency == 1) {
      if (
        this.FromLocal.PositionID > 6 &&
        this.FromLocal.PositionID !== 4 &&
        value !== "3"
      ) {
        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        console.log("in if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else if (
        //RUN: แก้ condition 22/04/2021
        this.FromLocal.PositionID <= 6 &&
        this.FromLocal.PositionID !== 4 &&
        value !== "4"
      ) {
        console.log("in else if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } else {
        console.log("in else ");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
      }
    } else {
      if (value !== "3") {
        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        console.log("in if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else {
        console.log("in else ");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
      }
    }

    if (isCompetency == 1) {
      console.log("in 1 ");
      if (
        this.FromLocal.PositionID == "19" &&
        SubSubToppicId.toString() == "2" &&
        value == "4"
      ) {
        console.log("in 2 ");

        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else if (
        //RUN: แก้ condition 22/04/2021
        this.FromLocal.PositionID == "19" &&
        SubSubToppicId.toString() == "2" &&
        value == "3"
      ) {
        console.log("in 3 ");

        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      }
    }
    console.log(
      "this.AnsData.ansForm",
      this.AnsData.ansForm
    );
    this.TotalClickPointTopicFunction(ToppicId, SubToppicId, SubSubToppicId);
  };

   handleSaveDraft = (ansSaveData, tableForm) => {
      tableForm.forEach((element) => {
        element.AnsForm = ansSaveData;
        element.SubSubTopics = [];
        element.SubTopics = [];
        element.Topics = [];
      });
  
      console.log("tableForm", tableForm);
  
      fetch(process.env.REACT_APP_API_URL+"/api/saveFormLeader", {
        method: "post",
  
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
  
        body: JSON.stringify({
          empid: this.props.location.state.record.empId,
          assessor: this.props.location.state.record.LeaderId,
          buttonaction: "1",
          jsonans: tableForm,
          formtypeid: "3"
        }),
      })
        .then((Response) => Response.json())
        .then((result) => {
          console.log("save draft result: " + JSON.stringify(result));
          if (result.status == "404") {
            // alert("บันทึกไม่สำเร็จ");
            //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021
          
  
            if (this.state.language == 'TH') {
              this.dialog.WarningDialog('บันทึกร่างไม่สำเร็จ')
            } else {
              this.dialog.WarningDialog('Unable to Save Draft')
            }
          } else {
  
            // alert("บันทึกร่างสำเร็จ");
            // window.location.href = "/workform";
            //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021
            if (this.state.language == 'TH') {
              this.dialog.SuccessDialog('บันทึกร่างสำเร็จ', '/leader')
            } else {
              this.dialog.SuccessDialog('Save Draft Success', '/leader')
            }
          }
  
  
        });
    };
  

  handleSubmit = (ansSaveData, tableForm, countTotalRequire) => {
    //RUN: ตรวจสอบ condition ว่ามีค่าจำนวน ans เท่ากับ form หรือไม่ 11/04/2012
    var tempArray = [];
    var tempArrayRemarkvalidation = [];

    tableForm.forEach((element) => {
      element.AnsForm = ansSaveData;
      element.SubSubTopics = [];
      element.SubTopics = [];
      element.Topics = [];
    });
    tempArray = countTotalRequire.filter((e) => {
      return e.Tooltip1TH == "";
    });
    
    console.log('tempArray',tempArray)
    console.log('ansform',ansSaveData)
    
 
    //RUN: ใช้ Condition Nested If ให้เข้า Condition ให้ถูกต้อง และ แสดง error ขึ้นมาตามลำดับ 11/04/2021
    if (ansSaveData.length == tempArray.length) {

      if (tempArrayRemarkvalidation.length == 0) {
        fetch(process.env.REACT_APP_API_URL+"/api/saveFormLeader", {

          method: "post",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },

          body: JSON.stringify({
            empid: this.props.location.state.record.empId,
            assessor: this.props.location.state.record.LeaderId,
            buttonaction: "2",
            jsonans: tableForm,
            formtypeid: "3"
          }),
        })
          .then((Response) => Response.json())
          .then((result) => {
            console.log("submit result: " + JSON.stringify(result));
            if (result.status == "404") {
              // alert("บันทึกไม่สำเร็จ");
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021
          

              if (this.state.language == 'TH') {
                this.dialog.WarningDialog(
                  'บันทึกไม่สำเร็จ')
              } else {
                this.dialog.WarningDialog(
                  'Unable to Save')
              }
            } else {
              // alert("บันทึกสำเร็จ");
              // window.location.href = "/workform";
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

              if (this.state.language == 'TH') {
                this.dialog.SuccessDialog('บันทึกสำเร็จ', '/leader')

                localStorage.removeItem("selfEvalStatus");

              } else {
                this.dialog.SuccessDialog('Save Success', '/leader')
                localStorage.removeItem("selfEvalStatus");


              }

              

            }

            
          });
      } else {

        if (this.state.language == 'TH') {
          this.dialog.WarningDialog(
            'บันทึกไม่สำเร็จ ข้อมูลเหตุผลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน')
        } else {
          this.dialog.WarningDialog(
            'Unable to save due to incomplete remark. Please check your assessment informations.')
        }
 
      }
    } else {
      // alert("บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน");
      //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

      if (this.state.language == 'TH') {
        this.dialog.WarningDialog(
          'บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน')
      } else {
        this.dialog.WarningDialog(
          'Unable to save due to incomplete data. Please check your assessment informations.')
      }
    }
  };


  TotalClickPointTopicFunction(TopicId, SubTopicId, SubSubTopicId) {
    var tempArray = [];
    this.AnsData.ansForm.forEach((e) => {
      tempArray.push({
        TopicId: e.TopicId,
        SubTopicId: e.SubTopicId,
        SubSubTopicId: e.SubSubTopicId,
        Point: e.Point,
        Remark: e.Remark,
        CalPoint: e.CalPoint,
        isCompetency: e.isCompetency,
      });
    });
    var temp = [];
    var temp2 = [];
    tempArray.forEach((e) => {
      if (temp2.length == 0) {
        temp2.push({
          TopicId: e.TopicId,
          CalPoint: e.CalPoint,
        });
      } else {
        temp = temp2.filter((e2) => {
          return e2.TopicId == e.TopicId;
        });
        if (temp.length == 0) {
          temp2.push({
            TopicId: e.TopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp2.forEach((e3) => {
            if (e3.TopicId == e.TopicId) {
              e3.CalPoint = e3.CalPoint + e.CalPoint;
            }
          });
        }
      }
    });
    this.AnsData.ansTotalClickTopic = temp2;

    var temp3 = [];
    var temp4 = [];
    tempArray.forEach((e) => {
      if (e.SubSubTopicId > 0) {
        if (temp3.length == 0) {
          temp3.push({
            TopicId: e.TopicId,
            SubTopicId: e.SubTopicId,
            SubSubTopicId: e.SubSubTopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp4 = temp3.filter((e2) => {
            return e2.TopicId == e.TopicId && e2.SubTopicId == e.SubTopicId;
          });
          if (temp4.length == 0) {
            temp3.push({
              TopicId: e.TopicId,
              SubTopicId: e.SubTopicId,
              SubSubTopicId: e.SubSubTopicId,
              CalPoint: e.CalPoint,
            });
          } else {
            temp3.forEach((e3) => {
              if (e3.TopicId == e.TopicId && e3.SubTopicId == e.SubTopicId) {
                e3.CalPoint = e3.CalPoint + e.CalPoint;
              }
            });
          }
        }
      }
    });
    this.AnsData.ansTotalClickSubSubTopic = temp3;
    var total = 0;
    this.AnsData.ansTotalClickTopic.forEach((e) => {
      total = total + e.CalPoint;
    });

    this.AnsData.TotalCalculate = total;
  }

  spinnerControl() {
    this.setState({ spinner: !this.state.spinner });
  }

  testarrayDupFunction(ToppicId, SubToppicId, SubSubToppicId) {
    console.log("testarrayDupFunction");
    var tempDup = [];
    //RUN: ยัดใส่เป็น ToString ให้หมดเนื่องจากส่งไปsave กับ ส่งคืนมา มีค่าdatatype อิอัยยยยยยยยยย 16/04/2021
    var tempToppicId = ToppicId.toString();
    var tempSubToppicId = SubToppicId.toString();
    var tempSubSubToppicId = SubSubToppicId.toString();
    tempDup = this.AnsData.ansForm.filter((e) => {
      return (
        e.TopicId.toString() !== tempToppicId ||
        e.SubTopicId.toString() !== tempSubToppicId ||
        e.SubSubTopicId.toString() !== tempSubSubToppicId
      );
    });
    console.log("tempDup", tempDup);
    return tempDup;
  }

  //RUN: เพิ่ม method getDefault เพื่อนำข้อมูลจาก savedraft เข้าไป set ค่าให้ 16/04/2021
  getDefaultScore(ToppicId, SubToppicId, SubSubToppicId) {
    var tempArray = [];
    tempArray = this.AnsData.ansForm.filter((e) => {
      return (
        e.TopicId == ToppicId &&
        e.SubTopicId == SubToppicId &&
        e.SubSubTopicId == SubSubToppicId
      );
    });
    if (tempArray.length > 0) {
      return tempArray[0].Point;
    } else {
      return null;
    }
  }

  splicingTitle(title) {
    var newtext = "";
    newtext = title.replace(/[0-9]/g, "");
    newtext = newtext.replace(/[.]/g, "");
    if (this.state.language == "TH") {
      newtext = newtext.replace(/\s/g, "");
    }
    return newtext;
  }

  //Run: new Structure 09/04/2021
  renderTable() {
    console.log("this.state.Tooltip", this.state.Tooltip);

    const listbuttonSubSubTopic = this.state.Tooltip.map(
      ({ SubSubToppicId, SubToppicId, ToppicId, Tooltip1TH }, Counts) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
        >
          {SubSubToppicId > 0 && (
            <div
              onChange={(e) => {
                this.handleChange(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value,
                  Counts
                );
              }}
            >
              <Radio.Group
                name="subsubtopic"
                buttonStyle="solid"
                defaultValue={this.getDefaultScore(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId
                )}
              >
                <Radio.Button value={5}>5</Radio.Button>
                <Radio.Button value={4}>4</Radio.Button>
                <Radio.Button value={3}>3</Radio.Button>
                <Radio.Button value={2}>2</Radio.Button>
                <Radio.Button value={1}>1</Radio.Button>
              </Radio.Group>
            </div>
          )}
        </div>
      )
    );

    const listbuttonSubTopic = this.state.Tooltip.map(
      ({ SubSubToppicId, SubToppicId, ToppicId, Tooltip1TH }, Counts) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={0}
          TooltipInfo={Tooltip1TH}
          style={{ marginLeft: 15 }}
        >
          {Tooltip1TH !== "topic" && SubSubToppicId == 0 && (
            <div
              onChange={(e) => {
                this.handleChange(
                  ToppicId,
                  SubToppicId,
                  0,
                  e.target.value,
                  Counts
                );
              }}
            >
              <Radio.Group
                name="subsubtopic"
                buttonStyle="solid"
                defaultValue={this.getDefaultScore(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId
                )}
              >
                <Radio.Button value={5}>5</Radio.Button>
                <Radio.Button value={4}>4</Radio.Button>
                <Radio.Button value={3}>3</Radio.Button>
                <Radio.Button value={2}>2</Radio.Button>
                <Radio.Button value={1}>1</Radio.Button>
              </Radio.Group>
            </div>
          )}
        </div>
      )
    );

    const listSubSubTopics = this.initArrays.SubSubTopicArr.map(
      (
        {
          TitleTH,
          TitleEN,
          SubToppicId,
          ToppicId,
          SubSubToppicId,
          DescriptionTH,
          DescriptionEN,
        },
        Indexes
      ) => (
        <div
          key={Indexes}
          ToppicIDs={ToppicId}
          SubIDs={SubToppicId}
          SubSubTopicId={SubSubToppicId}
          style={{
            padding: "15px 0px",
            paddingLeft: 20,
            paddingRight: 20,
            borderBottom: "1px solid #DCDCDC",
          }}
        >
          <Row>
            {this.state.language == "TH" ? (
              <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                <p style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                  {TitleTH}
                  {DescriptionTH}
                </p>
              </Col>
            ) : (
              <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                <p style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                  {TitleEN}
                  {DescriptionEN}
                </p>
              </Col>
            )}

            <Col
              xs={24}
              sm={24}
              md={6}
              lg={6}
              xl={6}
              style={{ textAlign: "center" }}
            >
              {listbuttonSubSubTopic.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.TooltipInfo !== "topic" &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              })}
            </Col>
          </Row>
        </div>
      )
    );

    const listSubTopics = this.initArrays.SubTopicArr.map(
      (
        {
          TitleTH,
          TitleEN,
          SubToppicId,
          ToppicId,
          SubSubToppicId,
          DescriptionTH,
          DescriptionEN,
        },
        Index
      ) => (
        <div
          key={Index}
          ToppicID={ToppicId}
          SubID={SubToppicId}
          SUSUSUS={SubSubToppicId}
        >
          <div
            style={{
              padding: "10px 20px 10px 20px",
              borderBottom: "1px solid #DCDCDC",
            }}
          >
            <Row>
              {this.state.language == "TH" ? (
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  <p>
                    <b> {TitleTH} </b> {DescriptionTH}
                  </p>
                </Col>
              ) : (
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  <p>
                    <b> {TitleEN} </b> {DescriptionEN}
                  </p>
                </Col>
              )}

              <Col
                xs={24}
                sm={24}
                md={6}
                lg={6}
                xl={6}
                style={{ textAlign: "center" }}
              >
                {listbuttonSubTopic.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId
                  );
                })}
              </Col>
            </Row>
          </div>

          <div>
            {listSubSubTopics.filter((e) => {
              return e.props.SubIDs == SubToppicId;
            })}
          </div>
        </div>
      )
    );

    const listItems = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div>
          <div
            style={{
              padding: "10px 15px",
              borderBottom: "1px solid #DCDCDC",
              background: "#E8F7FF",
            }}
          >
            <Row>
              {this.state.language == "TH" ? (
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <p key={ToppicId}>
                    <b> {TitleTH} </b>
                    {DescriptionTH}
                  </p>
                </Col>
              ) : (
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <p key={ToppicId}>
                    <b> {TitleEN} </b>
                    {DescriptionEN}
                  </p>
                </Col>
              )}
            </Row>
          </div>

          <div>
            {listSubTopics.filter((e) => {
              return e.props.ToppicID == ToppicId;
            })}
          </div>
        </div>
      )
    );

    return (
      <div style={{ widht: "80%", border: "1px solid #DCDCDC" }}>
        <div
          style={{
            padding: 15,
            backgroundColor: "#30BAFF",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          {this.state.language == "TH" ? (
            <Row>
              <Col span={18}> เกณฑ์การประเมินผล </Col>
              <Col span={6}> ระดับคะแนน </Col>
            </Row>
          ) : (
            <Row>
              <Col span={18}> Criteria </Col>
              <Col span={6}> Score </Col>
            </Row>
          )}
        </div>

        <div>{listItems}</div>
      </div>
    );
  }

  renderContentTH() {
    return (
      <div>
        {/* <Spin tip="Loading..." spinning={this.state.spinner}> */}

        <PageHeader
          className="site-page-header"
          onBack={() => window.history.back()}
          title={
            "แบบประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหาร : " +
            this.props.location.state.record.TitleTH +
            " " +
            this.props.location.state.record.FirstNameTH +
            " " +
            this.props.location.state.record.LastNameTH
          }
        />

        <h3 style={{ textAlign: "center", marginTop: 35 }}>
          แบบประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหารมหาวิทยาลัยพายัพ
          <br /> ประจำปีการศึกษา 2564
        </h3>

        <div style={{ width: "80%", margin: "auto", marginTop: 35 }}>
          {this.renderTable()}
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Button
              onClick={(e) => {
                this.handleSaveDraft(
                  this.AnsData.ansForm,
                  this.state.tableData
                );
              }}
            >
              บันทึกร่าง
            </Button>

            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.tableData,
                  //RUN: เพิ่มการนำตัวแปรเข้า handlesubmit 11/04/2012
                  this.state.Tooltip
                );
              }}
            >
              ส่งข้อมูล
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderContentEN() {
    return (
      <div>
        {/* <Spin tip="Loading..." spinning={this.state.spinner}> */}

        <PageHeader
          className="site-page-header"
          onBack={() => window.history.back()}
          title={
            "Appraisal of administrators on their leadership and administrative capacity : " +
            this.props.location.state.record.TitleEN +
            " " +
            this.props.location.state.record.FirstNameEN +
            " " +
            this.props.location.state.record.LastNameEN
          }
        />

        <div style={{ textAlign: "center", marginTop: 35 }}>
          <h3>
            Appraisal of administrators on their leadership and administrative
            capacity in accordance <br />  with principles of good governance for the
            Academic Year 2564
          </h3>
        </div>

        <div style={{ width: "80%", margin: "auto", marginTop: 35 }}>
          {this.renderTable()}
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Button
              onClick={(e) => {
                this.handleSaveDraft(
                  this.AnsData.ansForm,
                  this.state.tableData
                );
              }}
            >
              Draft
            </Button>

            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.tableData,
                  //RUN: เพิ่มการนำตัวแปรเข้า handlesubmit 11/04/2012
                  this.state.Tooltip
                );
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    console.log("resutl", this.state.tableData);

    return (
      <div>
        {this.state.language == "TH"
          ? this.renderContentTH()
          : this.renderContentEN()}
      </div>
    );
  }
}
